import { axios, Response } from '../index'
import { TherapistManager } from '../patients/get-clinic-patients'

export interface PatientManagers {
  therapistId: string
  accessProfileId: string
}

export interface CreateTherapistManager {
  patientId: string
  managers: PatientManagers[]
}

const createTherapistManager = (
  body: CreateTherapistManager
): Response<TherapistManager> => {
  return axios.post('/v1/therapists-responsible', body)
}

export default createTherapistManager
